export default "__VITE_PUBLIC_ASSET__69d28a00__"